import { renderTheme1 } from "./Theme1";
import { renderTheme2 } from "./Theme2";
import { renderTheme3 } from "./Theme3";
import { renderTheme4 } from "./Theme4";
import type { ThemeRenderer } from "./ISocialsThemeRenderer";

export class ThemeFactory {
  private static renderers: Record<string, ThemeRenderer> = {
    theme1: renderTheme1,
    theme2: renderTheme2,
    theme3: renderTheme3,
    theme4: renderTheme4,
  };

  public static getRenderer(theme: string): ThemeRenderer {
    return this.renderers[theme] || renderTheme1;
  }
}
